import routerOptions0 from "/codebuild/output/src4200334328/src/codestar-connections.eu-central-1.amazonaws.com/git-http/590183747426/eu-central-1/94facd3c-401c-440c-99a1-7824e47bf76e/studyportals/OmniSearch/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/codebuild/output/src4200334328/src/codestar-connections.eu-central-1.amazonaws.com/git-http/590183747426/eu-central-1/94facd3c-401c-440c-99a1-7824e47bf76e/studyportals/OmniSearch/src/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}